import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlocks1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 194,
	height: 194,
	viewBox: "0 0 194 194",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M96.78 183.57C144.71 183.57 183.56 144.72 183.56 96.79C183.56 48.86 144.71 10 96.78 10C48.85 10 10 48.85 10 96.78C10 144.71 48.85 183.56 96.78 183.56",
			fill: "#27385A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.19 56.2902C127.13 56.2902 127.98 55.7102 128.33 54.8402C128.68 53.9602 128.46 52.9602 127.77 52.3102L98.71 24.8302C97.82 23.9902 96.43 23.9902 95.54 24.8302L66.48 52.3102C65.8 52.9602 65.57 53.9602 65.92 54.8402C66.27 55.7202 67.12 56.2902 68.06 56.2902H126.18H126.19Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.92 104.28H50.6502C48.4902 104.28 46.7402 106.03 46.7402 108.18V155.54C46.7402 157.7 48.4902 159.45 50.6502 159.45H74.4302C74.3702 158.67 74.3402 157.89 74.3402 157.1C74.3402 142.32 84.3902 130.34 96.7802 130.34C109.17 130.34 119.23 142.32 119.23 157.1C119.23 157.89 119.19 158.68 119.14 159.45H142.92C145.08 159.45 146.82 157.7 146.82 155.54V108.18C146.82 106.03 145.07 104.28 142.92 104.28Z",
			fill: "#FF2180"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.69 59.3599H66.5198C64.8998 59.3599 63.5898 60.6699 63.5898 62.2899V98.2799C63.5898 99.8999 64.8998 101.21 66.5198 101.21H81.6098C81.3498 99.8699 81.1898 98.4799 81.1898 97.0499C81.1898 86.8999 88.0898 78.6699 96.5998 78.6699C105.11 78.6699 112.02 86.8999 112.02 97.0499C112.02 98.4799 111.87 99.8699 111.61 101.21H126.7C128.32 101.21 129.63 99.8999 129.63 98.2799V62.2899C129.63 60.6699 128.32 59.3599 126.7 59.3599",
			fill: "#1DBADF"
		})
	]
});
export default SvgBlocks1;
